import React, { useState } from 'react'
import { isEmpty, map } from 'lodash'
import Swiper from 'react-id-swiper'

import './swiper.min.css'
import styles from '../index.scss'
// 轮子地址 https://react-id-swiper.ashernguyen.site/
// 相关参数参考 https://2.swiper.com.cn/ || https://react-id-swiper.ashernguyen.site/
const LicenseSwiper = props => {
  const [swiperObj, updateSwiper] = useState(null)

  const banner = props.data
  const params = {
    lazy: true, // 懒加载
    loop: true, // 启用无限滚动
    effect: 'coverflow',
    // grabCursor: true, // 鼠标覆盖Swiper时指针变成抓手形状
    initialSlide: 1,
    centeredSlides: true, // 居中
    simulateTouch: false,
    loopedSlides: 3,
    slidesPerView: 'auto', // 会根据容器container的宽度调整slides数目，*PS：要配合loopedSlides loop一起使用，否则不生效
    coverflowEffect: {
      rotate: 0,
      stretch: 45, // 每个swiper-slide的间隔，值越小间隔越大
      depth: 200, // 值越大图越往后退
      modifier: 2, // depth和rotate和stretch的倍率，相当于depth*modifier、rotate*modifier、stretch*modifier，值越大这三个参数的效果越明显。
      shadows: true,
    },
    navigation: {
      // nextEl: '.swiper-button-next',
      // prevEl: '.swiper-button-prev',
    },
    pagination: {
      el: '.swiper-pagination',
      clickable: true,
      dynamicBullets: true,
    },
    getSwiper: swiper => {
      updateSwiper(swiper)
      // 事件监听 相关参数参考 https://swiperjs.com/api/#events
      swiper.on('slideChange', () => {
        // console.log(`slide changed : ${swiper.realIndex}`)
        props.handleSwiperChange(swiper.realIndex)
      })
    },
  }

  const goNext = () => {
    if (swiperObj !== null) {
      swiperObj.slideNext()
    }
  }
  const goPrev = () => {
    if (swiperObj !== null) {
      swiperObj.slidePrev()
    }
  }

  return (
    <div className={styles.iswiper}>
      <Swiper {...params}>
        {!isEmpty(banner) &&
          map(banner, (itm, idx) => {
            return (
              <div
                key={idx}
                onClick={() => props.handleClickBanner(itm)}
                className="swiper-slide"
              >
                <img src={itm} alt="" />
              </div>
            )
          })}
      </Swiper>
      <div
        className="swiper-button-next"
        style={{ position: 'absolute', right: '-60px' }}
        onClick={goNext}
      ></div>
      <div
        className="swiper-button-prev"
        style={{ position: 'absolute', left: '-60px' }}
        onClick={goPrev}
      ></div>
    </div>
  )
}

export default LicenseSwiper
